// extracted by mini-css-extract-plugin
export default {"container":"rQ-z","dimension":"sQ-z","dimensionLabels":"tQ-z"};